import {
  addTwitterCardScript,
  checkIfParsedElementIsTwitterCard,
  isTwitterCardEmbedCodeValid
} from '@fmpedia/html-tools'

export {
  addTwitterCardScript,
  checkIfParsedElementIsTwitterCard,
  isTwitterCardEmbedCodeValid
}

const X_WIDGETS_SRC = 'https://platform.x.com/widgets.js'
const TWITTER_WIDGETS_SRC = 'https://platform.twitter.com/widgets.js'

export function normalizeTwitterCardScriptSource(html) {
  return html ? html.split(X_WIDGETS_SRC).join(TWITTER_WIDGETS_SRC) : html
}
